import type { QuoteTotals } from 'paintscout'
export function calculateBalanceDue(totals: QuoteTotals) {
  const afterTax = Math.round(totals.after_tax * 100) / 100 || 0
  const amountPaid = Math.round(totals.amount_paid * 100) / 100 || 0

  return Math.round((afterTax - amountPaid) * 100) / 100
}
